export function getCurrentAuthRedirectPath(location = window.location) {
    return `${location.pathname}${location.search}${location.hash}`
}

export function getPostVerificationRedirectUrl({ redirectUrl, registrationRedirect, fallbackUrl, baseUrl }) {
    return (
        getOptionalUrl(redirectUrl, baseUrl) ??
        getOptionalUrl(registrationRedirect, baseUrl) ??
        new URL(fallbackUrl, baseUrl)
    )
}

function getOptionalUrl(value, baseUrl) {
    if (!value) return null
    return new URL(value, baseUrl)
}
